import React from "react";
import moment from "moment";

const CaseDetailCard = ({ label, user, date }) => {
  return (
    <div className="border-l-2 border-l-primaryColor bg-menubghover px-5 py-2 rounded-5">
      <p className="text-base font-medium text-subTextColor mb-0 capitalize">
        {user} {label} this on {moment.utc(date).local().format("DD/MM/YYYY hh:mm A")}
      </p>
    </div>
  );
};

export default CaseDetailCard;
